import React, {useEffect} from 'react'
import '../../App.css';
import HeroSection from '../HeroSection';
import HomeGallery from '../HomeGallery';
import Footer from '../Footer';


function Home() {
  useEffect(() => {
                  const timer = setTimeout(() => {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                      }, 50);
          
                  return () => clearTimeout(timer);
  }, []);
  return (
        <>
            <HeroSection />
            {/* Replaced the old boxed links with a photo gallery. */}
            <HomeGallery images={[
              '/images/img-car-64.jpg',
              '/images/img-car-27.jpg',
              '/images/img-car-41.jpg',
              '/images/img-car-24.jpg',
              '/images/img-motorsport-8.jpg',
              '/images/img-motorsport-26.jpg',
              '/images/img-motorsport-18.jpg',
              '/images/img-motorsport-24.jpg',
              '/images/img-portraits-11.jpg',
              '/images/img-portraits-6.jpg',
              '/images/img-portraits-15.jpg',
              '/images/img-sports-1.jpg',
              '/images/img-sports-6.jpg',
              '/images/img-travel-9.jpg',
              '/images/img-travel-3.jpg'
            ]} />
            <Footer />
        </>
    )
}

export default Home;
